import React from 'react';
import styled from '@emotion/styled';
import { Typography } from 'antd';
import { HomeWidgetsForm } from '../../../../types/home';
import { appStyles } from '../../../../styles';

export interface ProductPreviewInterface {
  id?: string;
  index?: number;
  image?: string;
  name?: string;
}

interface ExplorerPreviewProps {
  values?: HomeWidgetsForm;
  currentProduct?: ProductPreviewInterface;
  isMemberExclusive: boolean;
}

const { Text } = Typography;

export const ExplorerPreview = (props: ExplorerPreviewProps) => {
  const { values, currentProduct, isMemberExclusive } = props;
  const isBgImagePreview = isMemberExclusive && currentProduct && currentProduct?.image && currentProduct.image !== '';
  const styleObj = isBgImagePreview
    ? {
        backgroundImage: `url(${CSS.escape(currentProduct.image || '')})`,
        border: 'none',
        padding: 0,
      }
    : {
        backgroundImage: '',
      };
  return (
    <StyledExplorerPreview style={styleObj}>
      {values?.heading && <Text className="heading">{values?.heading}</Text>}
    </StyledExplorerPreview>
  );
};

const StyledExplorerPreview = styled.div`
  width: 75%;
  min-height: 297px;
  ${appStyles.borderGray}
  ${appStyles.borderRadiusModal}
  margin: 30% 12.5% 0;
  background: transparent linear-gradient(180deg, #7a91be 0%, #4e5157 100%) 0% 0% no-repeat padding-box;
  position: relative;
  padding: 0.75rem;
  background-size: contain;
  width: 75%;
  background-repeat: no-repeat;
  background-position: center;
  & .heading {
    position: absolute;
    top: -48px;
    left: 0;
    font-size: 16px;
  }
  & .description,
  & .title {
    font-size: 14px;
    ${appStyles.color.white}
  }
  & .wrap-description {
    padding-bottom: 1rem;
    padding-top: 0.5rem;
  }
  & .wrap-text {
    position: absolute;
    top: 38%;
    justify-content: center;
    display: flex;
    align-items: center;
    text-align: center;
    width: 86%;
  }
  & .wrap-btn {
    align-items: center;
    justify-content: center;
    display: flex;
  }
  & .ctaText {
    position: absolute;
    bottom: 1.2rem;
    border-radius: 10px;
    height: 36px;
  }
`;
